import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { updateUserTheme } from '../../repository/UserDAO';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const AppThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState('light');

  const toggleTheme = async (userId) => {
    const newTheme = themeMode === 'light' ? 'dark' : 'light';
    try {
        const result = await updateUserTheme(userId, newTheme);
        if (result.success) {
            setThemeMode(newTheme);
        } else {
            console.error("Failed to update theme:", result.error);
        }
    } catch (error) {
        console.error("Unexpected error while toggling theme:", error);
    }
};


  const toggleThemeNoFirebaseUpdate = () => {
    setThemeMode('light');
  };

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode,
        },
      }),
    [themeMode],
  );

  return (
    <ThemeContext.Provider value={{ themeMode, toggleTheme, setThemeMode, toggleThemeNoFirebaseUpdate }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
